import styled from "styled-components";
import { IoIosSearch } from "react-icons/io";
import Overlay from "../../Overlay";
import { useState } from "react";
import { useModal } from "../../../contexts/ModalContext";
import Modal from "../Modal";
import SmallLoading from "../SmallLoading";
import { useToast } from "../../../contexts/ToastContext";

import useApi from "../../../hooks/useApi";
const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f6f8fa;
    border-radius: 12px;
    margin: 20px 0 10px 0;
    color: #333;
    box-sizing: border-box;
    padding: 15px;
`
const Title = styled.p`
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    margin-bottom: 10px;
`
const ContainerInput = styled.div`
    width: 100%;
    height: 40px;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 15px;
`
const Input = styled.input`
    width: calc( 100% - 45px );
    height: 100%;
    border: none;
    outline: none;
    font-size: 14px;
    padding: 0 15px;
    box-sizing: border-box;
`
const ContainerIcon = styled.div`
    width: 40px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`
const SearchIcon = styled(IoIosSearch)`
    width: 30px;
    height: 30px;
    margin-right: 5px;
    color: #666;
    cursor: pointer;
`
const ContainerModalAdd = styled.div`
    width: 100%;
`
const ModalAddTitle = styled.p`
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    margin-bottom: 15px;
    color: #333;
`
const InfoModal = styled.p`
    font-size: 14px;
    margin: 3px 0;
    color: #333;
`
const BotaoAdicionar = styled.button`
    width: 100%;
    height: 40px;
    background-color: #009100;
    box-sizing: border-box;
    margin: 15px 0 0 0;
    border: none;
    outline: none;
    color: #fff;
    font-weight: bold;
    border-radius: 10px;
    cursor: pointer;
    transition: all.3s;
    &:hover{
        scale: 1.03;
    }
`
const ContainerUserSelected = styled.div`
    background: #fff;
    padding: 12px 15px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.08);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
`
const UserName = styled.p`
    color: #333;
    font-weight: 600;
    margin: 0;
`
const BtnRemoveColab = styled.button`
    box-sizing: border-box;
    background: #d9534f;
    border: none;
    color: white;
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
        background: #c9302c;
    }
`

const ColabMultiSelector = ({ colaboradores, setColaboradores, titulo, name }) => {
    const api = useApi();


    const { openModal, isModalOpen, closeModal } = useModal();
    const { notifyWarning } = useToast();

    const [loading, setLoading] = useState(true);

    const [matricula, setMatricula] = useState('');
    const [colaborador, setColaborador] = useState({});

    const searchColab = async () => {

        if (matricula.length !== 6) {

            notifyWarning('A matrícula deve conter 6 dígitos.');
            return;

        }

        setLoading(true);
        openModal( name ? `addColabInfo${ name }` : 'addColabInfo');

        try {

            const { data } = await api.post('/Painel/API/Desvios/ColabInfo/', {
                matricula: matricula
            })

            setColaborador(data);

        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }

    }

    const adicionarColab = (e) => {
        e.preventDefault();

        setColaboradores(prev => [...prev, colaborador]);
        setColaborador({});
        closeModal();
        setMatricula('');

    };

    const removerColab = (e, matricula) => {
        e.preventDefault();

        setColaboradores(prev =>
            prev.filter(colab => colab.MATRICULA !== matricula)
        );
    }

    return (
        <>
            <Container>
                <Title>{titulo ? titulo : "Adicionar Colaboradores"}</Title>
                <ContainerInput>
                    <Input
                        type="text"
                        placeholder="Digite a matrícula"
                        maxLength={6}
                        value={matricula}
                        onChange={(e) => setMatricula(e.target.value)}
                    />
                    <ContainerIcon>
                        <SearchIcon onClick={searchColab} />
                    </ContainerIcon>
                </ContainerInput>
                {
                    colaboradores.map(obj => (
                        <ContainerUserSelected>
                            <UserName>{obj.NOME}</UserName>
                            <BtnRemoveColab onClick={(e) => removerColab(e, obj.MATRICULA)} >REMOVER</BtnRemoveColab>
                        </ContainerUserSelected>
                    ))
                }
                {
                    isModalOpen( name ? `addColabInfo${ name }` : 'addColabInfo' ) && (
                        <Overlay state={true} >
                            <Modal size="sm" header close={closeModal} >
                                {
                                    loading ? (
                                        <SmallLoading />
                                    ) : (
                                        <ContainerModalAdd>
                                            <ModalAddTitle>Colaborador:</ModalAddTitle>
                                            <InfoModal><b>NOME:</b> {colaborador ? colaborador.NOME : ''}</InfoModal>
                                            <InfoModal><b>MATRICULA:</b> {colaborador ? colaborador.MATRICULA : ''}</InfoModal>
                                            <InfoModal><b>FUNÇÃO:</b> {colaborador ? colaborador.FUNCAO : ''}</InfoModal>
                                            <BotaoAdicionar onClick={(e) => adicionarColab(e)} >ADICIONAR</BotaoAdicionar>
                                        </ContainerModalAdd>
                                    )
                                }
                            </Modal>
                        </Overlay>
                    )
                }
            </Container>
        </>
    )
}

export default ColabMultiSelector;